<template>
  <div class="sub-nav-toolbar-wrapper">
    <div class="sub-nav-toolbar">
      <!-- video indicator button START -->
      <template v-if="video">
        <!-- :tag="'div'" -->
        <router-link
          :to="`/car/${carId}/video`"
          :class="['nav-video-btn-wrapper', 'nav-btn-wrapper']"
          @click="goToVideoRouterDidClick">
          <div class="nav-video-btn nav-btn">
            <div class="nav-btn-icon nav-video-btn-icon" />
          </div>
        </router-link>
      </template>
      <!-- video indicator button END -->

      <!-- car view360 indicate button START -->
      <template v-if="panorama">
        <div
          :class="['nav-view360-btn-wrapper', 'nav-btn-wrapper']"
          @click.prevent.stop="goToView360">
          <div class="nav-view360-btn nav-btn">
            <div class="nav-btn-icon nav-view360-btn-icon" />
          </div>
        </div>
      </template>
      <!-- car view360 indicate button END -->
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'GalleryToolbar',

  computed: {
    ...mapGetters('Car', [
      'carByCarId',
      'titleByCarId',
      'statusByCarId',
      'videoByCarId',
      'panoramaByCarId',
    ]),

    carId () {
      return this.$route.params.id
    },

    car () {
      return this.carByCarId(this.carId)
    },

    title () {
      return this.titleByCarId(this.carId)
    },

    status () {
      return this.statusByCarId(this.carId)
    },

    video () {
      return this.videoByCarId(this.carId)
    },

    panorama () {
      return this.panoramaByCarId(this.carId)
    },
  },

  methods: {
    // go to video
    goToVideoRouterDidClick () {
      gio(`track`, `zyc_h5_2_6_video_did_click`, {
        car_id: this.carId,
        car_title: this.title,
        car_status: this.status,
      })
    },

    // open view360 page externally
    goToView360 () {
      window.open(this.car.panorama, '_self')

      gio(`track`, `zyc_h5_2_7_360view_did_click`, {
        car_id: this.carId,
        car_title: this.title,
        car_status: this.status,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
// 视频，内饰 360
.sub-nav-toolbar-wrapper {
  position: absolute;
  width: 100px;
  height: 40px;
  left: 10px;
  bottom: 10px;
  z-index: 100;
}

.sub-nav-toolbar {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}

.nav-btn-wrapper.nav-video-btn-wrapper {
  margin-right: 10px;
}

.nav-btn-wrapper {
  width: 50%;
  height: 100%;
}

.nav-btn {
  width: 100%;
  height: 100%;
  font-size: 0.8rem;
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
}

.nav-video-btn-icon {
  width: 100%;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('https://static.nuonuo.com.cn/zycmp/car-detail_video-play-button.png');
}

.nav-view360-btn-icon {
  width: 100%;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('https://static.nuonuo.com.cn/zycmp/car-detail_view360-button.png');
}
</style>